import { number, node, shape, string } from 'prop-types'
import { divIcon } from 'leaflet'
import { Marker, Popup } from 'react-leaflet'
import { ICONE } from 'icons'
import { renderReactNodeAsHtml } from 'utils'

BaseMappaMarker.propTypes = {
  posizione: shape({
    latitudine: number.isRequired,
    longitudine: number.isRequired,
  }),
  color: string,
  children: node,
}

export default function BaseMappaMarker(props) {
  const {
    posizione,
    color = 'primary',
    children,
  } = props

  return (
    <Marker
      position={[posizione.latitudine, posizione.longitudine]}
      icon={MarkerIcona(color)}
    >
      {children && <Popup>{children}</Popup>}
    </Marker>
  )
}

function MarkerIcona(color) {
  return divIcon({
    html: HTML_ICONE[color],
    className: '',
    iconSize: [35, 35],
    iconAnchor: [17, 17]
  })
}

const HTML_ICONE = {
  primary: htmlIcon('#1976d2'),
  secondary: htmlIcon('#9c27b0'),
  success: htmlIcon('#2e7d32'),
  info: htmlIcon('#03a9f4'),
  warning: htmlIcon('#ed6c02'),
  error: htmlIcon('#d32f2f'),
}

function htmlIcon(color) {
  return renderReactNodeAsHtml(
    <ICONE.MAP_MARKER sx={{ fill: color }} fontSize='large' />
  )
}

BaseMappaMarkerIcona.propTypes = {
  color: string,
}

export function BaseMappaMarkerIcona(props) {
  const { color = 'primary' } = props
  return <span dangerouslySetInnerHTML={{ __html: HTML_ICONE[color] }} />
}

